import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { Link } from 'react-scroll';
import { INTRODATA, NAVDATA } from './Intro.constants';
import {
  StyledData,
  StyledDataContent,
  StyledDataItem,
  StyledDataList,
  StyledDataTitle,
  StyledDataValue,
  StyledHero,
  StyledHeroContainer,
  StyledHeroTitle,
  StyledIntro,
  StyledNav,
  StyledNavItem,
  StyledNavList
} from './Intro.styled';

type IntroProps = {
  manfreditesCount: number;
};

const Intro: React.FC<IntroProps> = ({ manfreditesCount }) => {
  const { t } = useI18n('developer-career-report-2023');
  const { locale } = useRouter();

  const navData = NAVDATA(t);
  const introData = INTRODATA(t, locale, manfreditesCount);

  return (
    <StyledIntro>
      <StyledHero>
        <StyledHeroContainer>
          <StyledHeroTitle>
            <span>{t('mandecar23.hero.pre-title')}</span>
            {t('mandecar23.hero.title')}
            <span className="year">2023</span>
          </StyledHeroTitle>
          <HtmlTrans
            ns="developer-career-report-2023"
            i18nKey="mandecar23.hero.desc"
          />
        </StyledHeroContainer>
      </StyledHero>
      <StyledNav>
        <Heading3>{t('mandecar23.nav.title')}</Heading3>
        <StyledNavList>
          {navData.map((item, index) => (
            <Link key={index} to={item.section} href={`#${item.section}`}>
              <StyledNavItem>
                <img src={item.img} alt="" />
                <span>{item.text}</span>
              </StyledNavItem>
            </Link>
          ))}
        </StyledNavList>
      </StyledNav>
      <StyledData>
        <StyledDataTitle>{t('mandecar23.data.title')}</StyledDataTitle>
        <HtmlTrans
          ns="developer-career-report-2023"
          i18nKey="mandecar23.data.desc"
        />
        <StyledDataList>
          {introData.map((item, index) => (
            <StyledDataItem key={index}>
              <StyledDataValue>{item.value}</StyledDataValue>
              <StyledDataContent>{item.text}</StyledDataContent>
            </StyledDataItem>
          ))}
        </StyledDataList>
      </StyledData>
    </StyledIntro>
  );
};

export default Intro;
